import React from 'react';
import { Twitter, Facebook, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  const socialLinks = [
    { icon: Twitter, href: 'https://x.com/cryptocom?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor', label: 'Twitter' },
    { icon: Facebook, href: 'https://www.facebook.com/CryptoComOfficial/', label: 'Facebook' },
    { icon: Instagram, href: 'https://www.instagram.com/cryptocomofficial/', label: 'Instagram' },
    { icon: Youtube, href: 'https://www.youtube.com/channel/UCOMprzxakZOqmY23LYIawmg', label: 'Youtube' }
  ];

  return (
    <footer className="bg-[#0B1426] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        <div className="flex flex-col items-center gap-6 sm:gap-8">
          {/* Logo and description */}
          <div className="text-center">
            <div className="mb-3 sm:mb-4 flex justify-center">
              <img 
                src="https://freepngimg.com/save/168836-currency-crypto-digital-free-hd-image/2000x458" 
                alt="Crypto.com" 
                className="h-8 sm:h-10 lg:h-12 w-auto"
              />
            </div>
            <p className="text-white/60 text-xs sm:text-sm">
              Cryptocurrency in Every Wallet™
            </p>
          </div>

          {/* Social Links */}
          <div className="flex gap-3 sm:gap-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 bg-white/5 hover:bg-blue-500 rounded-full flex items-center justify-center text-white/70 hover:text-white transition-all"
                aria-label={social.label}
              >
                <social.icon className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
            ))}
          </div>

          {/* Copyright */}
          <div className="pt-6 sm:pt-8 border-t border-white/10 w-full">
            <p className="text-white/60 text-xs sm:text-sm text-center">
              © 2025 Crypto.com. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
